"use client";
import * as React from "react";
const SvgMailFilled = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 14", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M14.4.5H1.6C.72.5 0 1.23 0 2.13v9.75c0 .89.72 1.62 1.6 1.62h12.8c.88 0 1.6-.73 1.6-1.62V2.12C16 1.23 15.28.5 14.4.5m0 3.25L8 7.81 1.6 3.75V2.13L8 6.19l6.4-4.07z" }));
export {
  SvgMailFilled as default
};
